import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';
import { mediaFilter } from '../../utils/image';
import { CategoriaI } from '../../models/home';
import { SELECT_CATEGORIAS_PRODUCTOS } from '../../constants/Select';

interface SortableImageItemProps {
  categoria: CategoriaI;
  index: number;
  onRemove: (index: number) => void;
  handleInputChange: (index: number, name: 'nombre' | 'categoria', value: string) => void;
}

const ItemCategoria: React.FC<SortableImageItemProps> = ({
  categoria,
  index,
  onRemove,
  handleInputChange,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: categoria.orden });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    display: 'flex',
    flexDirection: 'column' as const,
    marginBottom: 20,
    gap: 10,
  };

  const onChange = (e: SelectChangeEvent) => {
    console.log(e.target.value)
    handleInputChange(index, 'categoria', e.target.value);
  };

  const categoriasProductos = SELECT_CATEGORIAS_PRODUCTOS;

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
    >
      {/* Solo la imagen y el orden son arrastrables */}
      <div 
        {...listeners} 
        role="button"
        tabIndex={0}
        style={{ cursor: 'grab', touchAction: 'none', userSelect: 'none' }}
      >
        <img
          src={
            categoria.imagen?.startsWith('blob:')
              ? categoria.imagen
              : mediaFilter({ path: categoria.imagen })
          }
          alt={`preview-${index}`}
          className="w-[140px] h-[110px] object-cover mx-auto"
          draggable={false}
        />
        <p style={{ textAlign: 'center', fontSize: 12, userSelect: 'none' }}>Orden: {categoria.orden}</p>
      </div>
      
      <TextField     
        type="text"
        placeholder="Título"
        value={categoria.nombre}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          handleInputChange(index, 'nombre', e.target.value)
        }
      />

      <Select 
        name="categoria" 
        onChange={onChange} 
        value={categoria.categoria || ''}
      >
        {categoriasProductos.map((categoriaProducto, idx) => (
            <MenuItem key={idx} value={categoriaProducto}>{categoriaProducto}</MenuItem>
        ))}
      </Select>

      <button type='button' onClick={() => onRemove(index)}>Eliminar</button>
    </div>
  );
};

export default ItemCategoria;
